import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'
const Darts = () => {
  return (
    <SportsLayoutComp name={'Darts'}/>
  )
}

export default Darts